/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable max-len */
const React = require('react');
const PropTypes = require('prop-types');
const Card = require('@andes/card');
const { CardContent } = require('@andes/card');
const Button = require('@andes/button');
const { Link } = require('frontend-spa');
const MenuUtils = require('../../../../../utils/menu');
const { sanitizePath } = require('../../../../common/URLSanitizer');
const { getEventTracker } = require('../../../../../utils/event-tracker');

function PluginMainCard(props) {
  const { lang, platform, setActiveItem, pluginLink, title, text, buttonText, image, isImageEndAlign } = props;
  const Tracker = getEventTracker();

  return (
    <div className="plugins-main-card">
      <Card>
        <CardContent className="card-content">
          <div className="plugins-main-card-container">
            <div className="plugins-main-card__text">
              <p>{title}</p>
              <h1>{text}</h1>
              <Link
                to={`/developers/${lang}/guides/plugins${pluginLink}`}
                onClick={() => { Tracker.send('mpdevelopers/click_plugins_landing_banner'); setActiveItem(MenuUtils.getItemFromURLParent(sanitizePath(`/developers/${lang}/guides/plugins${pluginLink}`), platform.siteId.toLowerCase(), lang)); }}
              >
                <Button
                  className="plugins-main-card__button"
                  hierarchy="loud"
                >
                  {buttonText}
                </Button>
              </Link>
            </div>
            <div className={`plugins-main-card__image ${isImageEndAlign ? 'end' : ''}`}>
              {image}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

PluginMainCard.propTypes = {
  platform: PropTypes.shape({
    siteId: PropTypes.string,
  }).isRequired,
  lang: PropTypes.string.isRequired,
  setActiveItem: PropTypes.func.isRequired,
  pluginLink: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
};

module.exports = PluginMainCard;
